<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            d="M5.6155 20.9998C5.15517 20.9998 4.77083 20.8456 4.4625 20.5373C4.15417 20.229 4 19.8446 4 19.3843V6.61529C4 6.15496 4.15417 5.77063 4.4625 5.46229C4.77083 5.15396 5.15517 4.99979 5.6155 4.99979H7.3845V2.76904H8.4615V4.99979H15.6155V2.76904H16.6155V4.99979H18.3845C18.8448 4.99979 19.2292 5.15396 19.5375 5.46229C19.8458 5.77063 20 6.15496 20 6.61529V19.3843C20 19.8446 19.8458 20.229 19.5375 20.5373C19.2292 20.8456 18.8448 20.9998 18.3845 20.9998H5.6155ZM5.6155 19.9998H18.3845C18.5385 19.9998 18.6796 19.9357 18.8077 19.8075C18.9359 19.6794 19 19.5383 19 19.3843V10.6153H5V19.3843C5 19.5383 5.06408 19.6794 5.19225 19.8075C5.32042 19.9357 5.4615 19.9998 5.6155 19.9998ZM5 9.61504H19V6.61529C19 6.46129 18.9359 6.32021 18.8077 6.19204C18.6796 6.06388 18.5385 5.99979 18.3845 5.99979H5.6155C5.4615 5.99979 5.32042 6.06388 5.19225 6.19204C5.06408 6.32021 5 6.46129 5 6.61529V9.61504Z"
            fill="currentColor"
        />
        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V2.38477H8.23075V4.50002H15.8077V2.38477H17.3077V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80777H19V6.30777C19 6.23077 18.9679 6.16026 18.9038 6.09626C18.8398 6.0321 18.7692 6.00002 18.6923 6.00002H5.30775C5.23075 6.00002 5.16025 6.0321 5.09625 6.09626C5.03208 6.16026 5 6.23077 5 6.30777V8.80777Z"
            fill="currentColor"
        />
        <!-- FILL -->
        <path
            v-else
            d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V2.38477H8.23075V4.50002H15.8077V2.38477H17.3077V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'calendar-today-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
